import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PrizeNavigation from "../components/PrizeNavigation";
import LeagueFeatures from "../components/LeagueFeatures";
import styles from "./LeagueFeaturesSetup.module.css";

const LeagueFeaturesSetup = () => {
  const navigate = useNavigate();

  const handleNextClick = () => {
    navigate("/invitemembers");
  };

  return (
    <div className={styles.leagueFeaturesSetup}>
      <PrizeNavigation navigationButtonArea="/2813821-1@2x.png" />
      <div className={styles.content}>
        <p className={styles.leagueName}>Setup your league - step 2 of 3</p>
        <LeagueFeatures />
      </div>
    </div>
  );
};

export default LeagueFeaturesSetup;



